module.exports = __webpack_public_path__ + "static/media/goal.9f88d204.svg";